import React, { useEffect, useState } from "react"
import { Col, Container, Row, Table } from "react-bootstrap"
import { useNavigate, useParams } from "react-router-dom"
import Navbar from "../../../../Components/Navbar/Navbar"
import toast from "react-hot-toast"
import Modal from "antd/es/modal/Modal"
import "../../PurchaseOrders/PurchaseOrders.css"
import ElmhurstLogo from "../../../../Assets/Images/elmhurst-initial-logo.png"
import cleanLogo from "../../../../Assets/Images/Login/transparent_bg.png"
import {
  capitalizeFirstLetter,
  formatDate,
  numberFormat,
  toastStyle,
  refreshPage,
  formatDateSlash,
  TokenExpiry,
  dateFormat,
} from "../../../../Helpers/Utils/Common"
import {
  getSingleBankSP,
  getSingleCashSP,
  getSingleCheckSP,
  getSingleOthersSP,
} from "../../../../Helpers/apiCalls/Purchases/paySupplierApi"
import PIModal from "./PIModal"
import Moment from "moment"
import noDataImg from "../../../../Assets/Images/no-data-img.png"
import Footer from "../../../../Components/Footer/Footer"

export default function ViewPaySupplier() {
  const { id, type } = useParams()
  let navigate = useNavigate()

  const [inactive, setInactive] = useState(true)
  const [transaction, setTransaction] = useState([])
  const [items, setItems] = useState([])
  const [fileList, setFileList] = useState([])
  const [preview, setPreview] = useState(false)
  const [previewFile, setPreviewFile] = useState("")

  /* print modal handler */
  const [showPrintModal, setShowPrintModal] = useState(false)
  const handleShowPrintModal = () => setShowPrintModal(true)
  const handleClosePrintModal = () => setShowPrintModal(false)
  const [printPI, setPrintPI] = useState([])

  async function handlePrintPI() {
    toast.loading("Printing Transaction", { style: toastStyle() })
    handleClosePrintModal()
    setTimeout(() => {
      toast.dismiss()
      Print()
    }, 1000)
  }

  function Print() {
    let printContents = document.getElementById("printablediv").innerHTML
    let originalContents = document.body.innerHTML
    document.body.innerHTML = printContents
    window.print(printContents)
    document.body.innerHTML = originalContents
    refreshPage()
  }

  async function fetchSingleSuppliersPayment(id) {
    setPrintPI({})

    if (type === "cash") {
      const cash = await getSingleCashSP(id)
      if (cash.data) {
        var data = cash.data.data[0]
        setFileList(data.cash_slip_attachments)
        setPrintPI(data)
        setTransaction({
          supplier_name: data?.supplier_name || data?.vendor_name || "N/A",
          payee: data.payee || "N/A",
          payment_date: dateFormat(data.payment_date),
          acknowledged_by: data.acknowledged_by || "N/A",
          particulars: data.particulars,
          amount: data.total_amount,
          added_on: data.added_on,

          total_amount: data.total_amount,
          withholding_tax_total: data.withholding_tax_total,
          subtotal: data.subtotal,
          total_others: data.total_others,
          grand_total: data.grand_total,
        })
        var cashEntries = data.cash_entries.map((entry) => {
          var info = entry
          info.added_on = formatDateSlash(entry.added_on)
          return info
        })
        setItems(cashEntries)
      } else {
        // TokenExpiry(cash);
      }
    } else if (type === "check") {
      const check = await getSingleCheckSP(id)
      if (check.data) {
        var data = check.data.data[0]
        setFileList(data.check_slip_attachments)
        setPrintPI(data)
        setTransaction({
          bank_name: data.bank_name || "N/A",
          check_date: dateFormat(data.check_date),
          issued_date: dateFormat(data.issued_date),
          check_no: data.check_no,
          supplier_name: data?.supplier_name || data?.vendor_name || "N/A",
          payee: data.payee || "N/A",
          acknowledged_by: data.acknowledged_by || "N/A",
          particulars: data.particulars,
          amount: data.total_amount,
          added_on: data.added_on,

          total_amount: data.total_amount,
          withholding_tax_total: data.withholding_tax_total,
          subtotal: data.subtotal,
          total_others: data.total_others,
          grand_total: data.grand_total,
        })
        var checkEntries = data.check_entries.map((entry) => {
          var info = entry
          info.added_on = formatDateSlash(entry.added_on)
          return info
        })
        setItems(checkEntries)
      } else {
        TokenExpiry(check)
      }
    } else if (type === "bank") {
      const bank = await getSingleBankSP(id)
      if (bank.data) {
        var data = bank.data.data[0]
        setFileList(data.bank_slip_attachments)
        setPrintPI(data)
        setTransaction({
          payment_date: dateFormat(data.payment_date),
          transaction_fee: data.transaction_fee,
          reference_no: data.reference_no,
          amount: data.total_amount,
          payee: data.payee,
          particulars: data.particulars,
          acknowledged_by: data.acknowledged_by,

          // FROM BANK DETAILS
          bank_from_name: data.bank_from_name,
          from_account_no: data.from_account_no,
          from_account_name: data.from_account_name,

          // TO BANK DETAILS
          bank_to_name: data.bank_to,
          to_account_no: data.to_account_no,
          to_account_name: data.to_account_name,

          supplier_name: data?.supplier_name || data?.vendor_name || "N/A",
          added_on: data.added_on,

          total_amount: data.total_amount,
          withholding_tax_total: data.withholding_tax_total,
          subtotal: data.subtotal,
          total_others: data.total_others,
          grand_total: data.grand_total,
        })
        var bankEntries = data.bank_entries.map((entry) => {
          var info = entry
          info.added_on = dateFormat(entry.added_on)
          return info
        })
        setItems(bankEntries)
      } else {
        TokenExpiry(bank)
      }
    } else if (type === "other" || type === "others") {
      const other = await getSingleOthersSP(id)
      if (other.data) {
        var data = other.data.data[0]
        setFileList(data.other_slip_attachments)
        setPrintPI(data)
        setTransaction({
          supplier_name: data?.supplier_name || data?.vendor_name || "N/A",
          payee: data.payee || "N/A",
          payment_date: dateFormat(data.payment_date),
          acknowledged_by: data.acknowledged_by || "N/A",
          particulars: data.particulars,
          amount: data.total_amount,
          added_on: data.added_on,
          transaction_type: data.transaction_type,
          transaction_no: data.transaction_no,

          total_amount: data.total_amount,
          withholding_tax_total: data.withholding_tax_total,
          subtotal: data.subtotal,
          total_others: data.total_others,
          grand_total: data.grand_total,
        })
        var otherEntries = data.other_entries.map((entry) => {
          var info = entry
          info.added_on = dateFormat(entry.added_on)
          return info
        })
        setItems(otherEntries)
      } else {
        // TokenExpiry(cash);
      }
    }
  }

  function numberToWords(number) {
    const units = [
      "",
      "one",
      "two",
      "three",
      "four",
      "five",
      "six",
      "seven",
      "eight",
      "nine",
    ]
    const teens = [
      "ten",
      "eleven",
      "twelve",
      "thirteen",
      "fourteen",
      "fifteen",
      "sixteen",
      "seventeen",
      "eighteen",
      "nineteen",
    ]
    const tens = [
      "",
      "",
      "twenty",
      "thirty",
      "forty",
      "fifty",
      "sixty",
      "seventy",
      "eighty",
      "ninety",
    ]
    const scales = ["", "thousand", "million", "billion", "trillion"]

    function convertChunk(number) {
      const hundreds = Math.floor(number / 100)
      const tensUnits = number % 100

      let parts = []

      if (hundreds > 0) {
        parts.push(units[hundreds] + " hundred")
      }

      if (tensUnits > 0) {
        if (tensUnits < 10) {
          parts.push(units[tensUnits])
        } else if (tensUnits < 20) {
          parts.push(teens[tensUnits - 10])
        } else {
          const tensDigit = Math.floor(tensUnits / 10)
          const unitsDigit = tensUnits % 10
          if (unitsDigit > 0) {
            parts.push(tens[tensDigit] + "-" + units[unitsDigit])
          } else {
            parts.push(tens[tensDigit])
          }
        }
      }

      return parts.join(" ")
    }

    function convert(number) {
      if (number === 0) return "zero"

      let chunkIndex = 0
      let words = []

      while (number > 0) {
        const chunk = number % 1000
        if (chunk !== 0) {
          const chunkWords = convertChunk(chunk)
          const scale = scales[chunkIndex]
          if (scale) {
            words.unshift(scale)
          }
          words.unshift(chunkWords)
        }

        number = Math.floor(number / 1000)
        chunkIndex++
      }

      return words.join(" ")
    }

    const integerPart = Math.floor(number)
    const decimalPart = Math.round((number - integerPart) * 100)
    const integerWords = convert(integerPart)
    const decimalWords =
      decimalPart > 0 ? " and " + convert(decimalPart) + " cents" : ""

    return `${integerWords} pesos${decimalWords}`
  }

  function renderTable() {
    return (
      <Table>
        <thead>
          <tr>
            <th>Entry</th>
            <th>Invoice Date</th>
            <th>Invoice Details</th>
            <th>Amount</th>
            <th>Service Fee</th>
            <th>Withholding Tax</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => {
            return (
              <tr key={item.id}>
                <td className="sentence">{item.invoice_label}</td>
                <td>{dateFormat(item.added_on)}</td>
                <td>
                  <button
                    type="button"
                    className="button-primary view-btn me-3"
                    onClick={() => handleViewPayment(item.receive_id, id, type)}
                  >
                    View
                  </button>
                </td>
                <td>PHP {numberFormat(item.amount)}</td>
                <td>PHP {numberFormat(item.service_fee_payment)}</td>
                <td>PHP {numberFormat(item.withholding_tax)}</td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  function renderPrintTable() {
    return (
      <Table className="align-middle">
        <thead>
          <tr>
            <th>Entry</th>
            <th>Invoice Date</th>
            <th>Amount</th>
            <th>Service Fee</th>
            <th>Withholding Tax</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => {
            return (
              <tr key={item.id} className="req-table-w-border-bottom">
                <td className="sentence req-table-w-border-sides">
                  {item.invoice_label}
                </td>
                <td className="req-table-w-border-sides">{item.added_on}</td>
                <td className="req-table-w-border-sides">
                  PHP {numberFormat(item.amount)}
                </td>
                <td className="req-table-w-border-sides">
                  PHP {numberFormat(item.service_fee_payment)}
                </td>
                <td className="req-table-w-border-sides">
                  PHP {numberFormat(item.withholding_tax)}
                </td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  function handleViewPayment(id, bank, type) {
    window.open("/purchaseinvoices/print/" + id, "_blank")
  }

  useEffect(() => {
    fetchSingleSuppliersPayment(id)
  }, [])

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive)
          }}
          active={"PURCHASE PAYMENTS"}
        />
      </div>
      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        <Row className="mb-4">
          <Col xs={12} lg={8}>
            <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2">
              {" "}
              VIEW TRANSACTION
            </h1>
          </Col>
          <Col xs={12} lg={1}></Col>
          <Col xs={12} lg={3}>
            <span className="PI-header2">DOCUMENT NO. {id}</span>
          </Col>
        </Row>

        {/* content */}
        <div className="review-form mb-3">
          {/* TRANSACTION/PAYMENT DETAILS */}
          {type === "cash" && (
            <>
              <Row className="review-container py-3">
                <Row>
                  <Col xs={6} lg={3}>
                    <span className="review-label">Supplier Name</span>
                    <br />
                    <span className="review-data ">
                      {transaction.supplier_name}
                    </span>
                  </Col>
                  <Col xs={6} lg={3}>
                    <span className="review-label ">Payee</span>
                    <br />
                    <span className="review-data ">{transaction.payee}</span>
                  </Col>
                  <Col xs={6} lg={3} className="mt-2 mt-lg-0">
                    <span className="review-label ">Payment Date</span>
                    <br />
                    <span className="review-data ">
                      {transaction.payment_date}
                    </span>
                  </Col>
                  <Col xs={6} lg={3} className="mt-2 mt-lg-0">
                    <span className="review-label">Payment Mode</span>
                    <br />
                    <span className="review-data ">{type}</span>
                  </Col>
                </Row>
              </Row>
              <Row className="review-container py-3">
                <Row>
                  <Col>
                    <span className="review-label ">Acknowledged By</span>
                    <br />
                    <span className="review-data ">
                      {transaction.acknowledged_by}
                    </span>
                  </Col>
                  <Col>
                    <span className="review-label ">Remarks</span>
                    <br />
                    <span className="review-data ">
                      {transaction.particulars}
                    </span>
                  </Col>
                </Row>
              </Row>
            </>
          )}
          {type === "check" && (
            <>
              <Row className="review-container py-3">
                <Row>
                  <Col xs={6} lg={3}>
                    <span className="review-label ">Bank</span>
                    <br />
                    <span className="review-data ">
                      {transaction.bank_name}
                    </span>
                  </Col>
                  <Col xs={6} lg={3}>
                    <span className="review-label ">Check Date</span>
                    <br />
                    <span className="review-data ">
                      {transaction.check_date}
                    </span>
                  </Col>
                  <Col xs={6} lg={3} className="mt-2 mt-lg-0">
                    <span className="review-label ">Issue Date</span>
                    <br />
                    <span className="review-data ">
                      {transaction.issued_date}
                    </span>
                  </Col>
                  <Col xs={6} lg={3} className="mt-2 mt-lg-0">
                    <span className="review-label ">Check No.</span>
                    <br />
                    <span className="review-data ">{transaction.check_no}</span>
                  </Col>
                </Row>
              </Row>
              <Row className="review-container py-3">
                <Row>
                  <Col xs={6} lg={3}>
                    <span className="review-label ">Supplier Name</span>
                    <br />
                    <span className="review-data ">
                      {transaction.supplier_name}
                    </span>
                  </Col>
                  <Col xs={6} lg={3}>
                    <span className="review-label ">Payee</span>
                    <br />
                    <span className="review-data ">{transaction.payee}</span>
                  </Col>
                  <Col xs={6} lg={3} className="mt-2 mt-lg-0">
                    <span className="review-label ">Acknowledged By</span>
                    <br />
                    <span className="review-data ">
                      {transaction.acknowledged_by}
                    </span>
                  </Col>
                  <Col xs={6} lg={3} className="mt-2 mt-lg-0">
                    <span className="review-label ">Payment Mode</span>
                    <br />
                    <span className="review-data ">{type}</span>
                  </Col>
                </Row>
              </Row>
              <Row className="review-container py-3">
                <Row>
                  <Col>
                    <span className="review-label ">Remarks</span>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <span className="review-data ">
                      {transaction.particulars}
                    </span>
                  </Col>
                </Row>
              </Row>
            </>
          )}
          {type === "bank" && (
            <>
              <Row className="review-container py-3">
                <Row>
                  <Col xs={6} lg={4}>
                    <span className="review-label ">From Bank</span>
                    <br />
                    <span className="review-data ">
                      {transaction.bank_from_name}
                    </span>
                  </Col>
                  <Col xs={6} lg={4}>
                    <span className="review-label ">Payment Date</span>
                    <br />
                    <span className="review-data ">
                      {transaction.payment_date}
                    </span>
                  </Col>
                  <Col xs={6} lg={4} className="mt-2 mt-lg-0">
                    <span className="review-label ">Payment Mode</span>
                    <br />
                    <span className="review-data ">
                      {capitalizeFirstLetter(type)}
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col xs={6} lg={4} className="mt-2 mt-lg-0">
                    <span className="review-label ">Account Number</span>
                    <br />
                    <span className="review-data ">
                      {transaction.from_account_no}
                    </span>
                  </Col>
                  <Col xs={6} lg={4} className="mt-2 mt-lg-0">
                    <span className="review-label ">Account Name</span>
                    <br />
                    <span className="review-data ">
                      {transaction.from_account_name}
                    </span>
                  </Col>
                  <Col xs={6} lg={4} className="mt-2 mt-lg-0">
                    <span className="review-label ">Reference No.</span>
                    <br />
                    <span className="review-data ">
                      {transaction.reference_no}
                    </span>
                  </Col>
                </Row>
              </Row>

              <Row className="review-container py-3">
                <Row>
                  <Col xs={6} lg={4}>
                    <span className="review-label ">To Bank</span>
                    <br />
                    <span className="review-data ">
                      {transaction.bank_to_name}
                    </span>
                  </Col>
                  <Col xs={6} lg={4}>
                    <span className="review-label ">Supplier Name</span>
                    <br />
                    <span className="review-data ">
                      {transaction.supplier_name}
                    </span>
                  </Col>
                  <Col xs={6} lg={4} className="mt-2 mt-lg-0">
                    <span className="review-label ">Payee</span>
                    <br />
                    <span className="review-data ">{transaction.payee}</span>
                  </Col>
                </Row>
                <Row>
                  <Col xs={6} lg={4} className="mt-2 mt-lg-0">
                    <span className="review-label ">Account Number</span>
                    <br />
                    <span className="review-data ">
                      {transaction.to_account_no}
                    </span>
                  </Col>
                  <Col xs={6} lg={4} className="mt-2 mt-lg-0">
                    <span className="review-label ">Account Name</span>
                    <br />
                    <span className="review-data ">
                      {transaction.to_account_name}
                    </span>
                  </Col>
                  <Col xs={6} lg={4} className="mt-2 mt-lg-0">
                    <span className="review-label ">Acknowledged By</span>
                    <br />
                    <span className="review-data ">
                      {transaction.acknowledged_by}
                    </span>
                  </Col>
                </Row>
              </Row>
              <Row className="review-container py-3">
                <Row>
                  <Col>
                    <span className="review-label ">Remarks</span>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <span className="review-data ">
                      {transaction.particulars}
                    </span>
                  </Col>
                </Row>
              </Row>
            </>
          )}
          {(type === "other" || type === "others") && (
            <>
              <Row className="review-container py-3">
                <Row>
                  <Col>
                    <span className="review-label ">Supplier Name</span>
                  </Col>
                  <Col>
                    <span className="review-label ">Payee</span>
                  </Col>
                  <Col>
                    <span className="review-label ">Payment Date</span>
                  </Col>
                  <Col>
                    <span className="review-label ">Payment Mode</span>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <span className="review-data ">
                      {transaction.supplier_name}
                    </span>
                  </Col>
                  <Col>
                    <span className="review-data ">{transaction.payee}</span>
                  </Col>
                  <Col>
                    <span className="review-data ">
                      {transaction.payment_date}
                    </span>
                  </Col>
                  <Col>
                    <span className="review-data ">{type}</span>
                  </Col>
                </Row>
              </Row>
              <Row className="review-container py-3">
                <Row>
                  <Col>
                    <span className="review-label ">Type</span>
                  </Col>
                  <Col>
                    <span className="review-label ">Reference No.</span>
                  </Col>
                  <Col>
                    <span className="review-label ">Acknowledged By</span>
                  </Col>
                  <Col>
                    <span className="review-label ">Remarks</span>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <span className="review-data ">
                      {transaction.transaction_type}
                    </span>
                  </Col>
                  <Col>
                    <span className="review-data ">
                      {transaction.transaction_no}
                    </span>
                  </Col>
                  <Col>
                    <span className="review-data ">
                      {transaction.acknowledged_by}
                    </span>
                  </Col>
                  <Col>
                    <span className="review-data ">
                      {transaction.particulars}
                    </span>
                  </Col>
                </Row>
              </Row>
            </>
          )}

          {/* INVOICES */}
          {/* <div className="mt-4 d-flex flex-column">
                        <span className="review-data mb-2 nc-modal-custom-row">
                            APPLIED TO THE FOLLOWING INVOICES
                        </span>
                    </div> */}
          <div className="mt-4 d-flex flex-column">
            <span className="review-data mb-2">APPLIED INVOICES</span>
            <div className="review-purchased-items purchased-items">
              {renderTable()}
            </div>
          </div>
          <Row className="my-2 me-5 align-right pb-2 justify-content-end">
            <Col className="pt-3">
              <Row className="mb-3">
                <Col
                  xs={8}
                  lg={10}
                  className="text-end print-table-footer-label"
                >
                  TOTAL AMOUNT
                </Col>
                <Col
                  xs={4}
                  lg={2}
                  className="text-end print-table-footer-data ps-4"
                >
                  {numberFormat(transaction.total_amount)}
                </Col>
              </Row>
              <Row className="mb-3">
                <Col
                  xs={8}
                  lg={10}
                  className="text-end print-table-footer-label"
                >
                  TOTAL WHT
                </Col>
                <Col
                  xs={4}
                  lg={2}
                  className="text-end print-table-footer-data ps-4"
                >
                  {numberFormat(transaction.withholding_tax_total)}
                </Col>
              </Row>
              <Row className="mb-3">
                <Col
                  xs={8}
                  lg={10}
                  className="text-end print-table-footer-label"
                >
                  SUBTOTAL
                </Col>
                <Col
                  xs={4}
                  lg={2}
                  className="text-end print-table-footer-data ps-4"
                >
                  {numberFormat(transaction.subtotal)}
                </Col>
              </Row>
              <Row className="mb-3">
                <Col
                  xs={8}
                  lg={10}
                  className="text-end print-table-footer-label"
                >
                  TOTAL OTHERS
                </Col>
                <Col
                  xs={4}
                  lg={2}
                  className="text-end print-table-footer-data ps-4"
                >
                  {numberFormat(transaction.total_others)}
                </Col>
              </Row>
              <Row className="mb-3">
                <Col
                  xs={8}
                  lg={10}
                  className="bold text-end print-table-footer-label"
                >
                  GRAND TOTAL
                </Col>
                <Col
                  xs={4}
                  lg={2}
                  className="bold text-end print-table-footer-data ps-4"
                >
                  {numberFormat(transaction.grand_total)}
                </Col>
              </Row>
            </Col>
          </Row>
          <div className="mt-4 noPrint">
            <Row className="review-data mb-2">FILE ATTACHMENTS</Row>
            <Row className="">
              {fileList &&
                fileList.map((attachment) => (
                  <Col
                    xs={1}
                    onClick={() => {
                      setPreviewFile(attachment.file_url)
                      setPreview(true)
                    }}
                    className="cursor-pointer preview-container"
                  >
                    <img src={attachment.file_url} className="img-preview" />
                  </Col>
                ))}
              {!fileList ||
                (fileList.length === 0 && (
                  <Col xs={1}>
                    <div className="no-data-cont d-flex justify-content-left preview-container">
                      <img
                        src={noDataImg}
                        alt="no data found"
                        className="img-preview"
                      />
                    </div>
                  </Col>
                ))}
            </Row>
          </div>
          {/* <div className="d-flex justify-content-end pt-5">
                        <button
                            type="button"
                            className="button-secondary me-3"
                            onClick={() => navigate("/paysuppliers")}
                        >
                            Close
                        </button>
                        <button
                            type="button"
                            className="button-primary me-3"
                            onClick={handleShowPrintModal}
                        >
                            Print
                        </button>
                    </div> */}
        </div>
        <div className="d-flex justify-content-end pt-1">
          <button
            type="button"
            className="button-secondary me-3"
            onClick={() => navigate("/paysuppliers")}
          >
            Close
          </button>
          <button
            type="button"
            className="button-primary"
            onClick={handleShowPrintModal}
          >
            Print
          </button>
        </div>
        <br />
      </div>
      {/* modals */}
      <PIModal
        show={showPrintModal}
        hide={handleClosePrintModal}
        type="print"
        page="transaction"
        handler={handlePrintPI}
      />
      <Modal
        open={preview}
        title={""}
        footer={null}
        onCancel={() => setPreview(false)}
      >
        <img
          alt="example"
          style={{
            width: "100%",
          }}
          src={previewFile}
        />
      </Modal>

      {/* PRINT VIEW */}
      <div className="print-container px-3 py-2 display-none" id="printablediv">
        <div className="print-header-elm d-flex flex-row">
          <div className="w-full">
            <div className="print-top d-flex justify-content-start py-1">
              <img src={ElmhurstLogo} className="print-logo-elm" alt="" />
            </div>
            <div className="print-top">
              <h5 className="print-shop-header-elm d-flex justify-content-start print-data">
                497 D Molave Extension Lahug (Pob.) Cebu City
              </h5>
              <h5 className="print-shop-header-elm d-flex justify-content-start print-data">
                San Roque, Cebu City
              </h5>
              <h5 className="print-shop-header-elm d-flex justify-content-start print-data">
                VAT REG. TIN: 629-196-359-000
              </h5>
            </div>
          </div>
          <div className="purchase-order-number-print-container w-full">
            <h1 className="purchase-order-title-print-elm">PAYMENT VOUCHER</h1>
            <div className="po-date-elm">
              <div className="po-date-and-number">
                <h5 className="print-shop-header-elm d-flex justify-content-end print-data">
                  Payment Date:{" "}
                  {Moment(transaction.added_on).format("MMMM DD, yyyy")}
                </h5>
                <h5 className="print-shop-header-elm d-flex justify-content-end print-data">
                  Document No.: {id}
                </h5>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-5">
          {type === "cash" && (
            <>
              <Row>
                <Col xs={6} lg={5} md={4}>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Supplier Name:
                    </Col>
                    <Col xs={6} className="print-data">
                      {transaction.supplier_name}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Payee:
                    </Col>
                    <Col xs={6} className="print-data">
                      {transaction.payee}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Payment Mode:
                    </Col>
                    <Col xs={6} className="print-data">
                      Cash
                    </Col>
                  </div>
                </Col>
                <Col xs={6} lg={5} md={6}>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Payment Date:
                    </Col>
                    <Col xs={7} className="print-data">
                      {transaction.payment_date}
                    </Col>
                  </div>
                  {/* <div className="d-flex my-2 align-items-center">
                                        <Col xs={4} className="print-label">
                                            Acknowledged By:
                                        </Col>
                                        <Col xs={6} className="print-data">
                                            {transaction.acknowledged_by}
                                        </Col>
                                    </div> */}
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Remarks:
                    </Col>
                    <Col xs={6} className="print-data">
                      {transaction.particulars}
                    </Col>
                  </div>
                </Col>
              </Row>
            </>
          )}
          {type === "check" && (
            <>
              <Row>
                <Col xs={6} lg={5} md={4}>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Supplier Name:
                    </Col>
                    <Col xs={6} className="print-data">
                      {transaction.supplier_name}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Payee:
                    </Col>
                    <Col xs={6} className="print-data">
                      {transaction.payee}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Payment Mode:
                    </Col>
                    <Col xs={6} className="print-data">
                      Check
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Bank:
                    </Col>
                    <Col xs={6} className="print-data">
                      {transaction.bank_name}
                    </Col>
                  </div>
                </Col>
                <Col xs={6} lg={5} md={4}>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Check No.:
                    </Col>
                    <Col xs={6} className="print-data">
                      {transaction.check_no}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Check Date:
                    </Col>
                    <Col xs={6} className="print-data">
                      {transaction.check_date}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Issue Date:
                    </Col>
                    <Col xs={6} className="print-data">
                      {transaction.issued_date}
                    </Col>
                  </div>
                  {/* <div className="d-flex my-2 align-items-center">
                                        <Col xs={4} className="print-label">
                                            Acknowledged By:
                                        </Col>
                                        <Col xs={6} className="print-data">
                                            {transaction.acknowledged_by}
                                        </Col>
                                    </div> */}
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Remarks:
                    </Col>
                    <Col xs={6} className="print-data">
                      {transaction.particulars}
                    </Col>
                  </div>
                </Col>
              </Row>
            </>
          )}
          {type === "bank" && (
            <>
              <Row>
                <Col xs={6} lg={5} md={4}>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Supplier Name:
                    </Col>
                    <br />
                    <Col xs={6} className="print-data">
                      {transaction.supplier_name}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Payee:
                    </Col>
                    <br />
                    <Col xs={6} className="print-data">
                      {transaction.payee}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Payment Mode:
                    </Col>
                    <br />
                    <Col xs={6} className="print-data">
                      Bank
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      From Bank:
                    </Col>
                    <br />
                    <Col xs={6} className="print-data">
                      {transaction.bank_from_name}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Account No.:
                    </Col>
                    <br />
                    <Col xs={6} className="print-data">
                      {transaction.from_account_no}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Account Name:
                    </Col>
                    <br />
                    <Col xs={6} className="print-data">
                      {transaction.from_account_name}
                    </Col>
                  </div>
                </Col>
                <Col xs={6} lg={5} md={4}>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Payment Date:
                    </Col>
                    <br />
                    <Col xs={6} className="print-data">
                      {dateFormat(transaction.payment_date)}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Reference No.:
                    </Col>
                    <br />
                    <Col xs={6} className="print-data">
                      {transaction.reference_no}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Remarks:
                    </Col>
                    <br />
                    <Col xs={6} className="print-data">
                      {transaction.particulars}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      To Bank:
                    </Col>
                    <br />
                    <Col xs={6} className="print-data">
                      {transaction.bank_to_name}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Account No.:
                    </Col>
                    <br />
                    <Col xs={6} className="print-data">
                      {transaction.to_account_no}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Account Name:
                    </Col>
                    <br />
                    <Col xs={6} className="print-data">
                      {transaction.to_account_name}
                    </Col>
                  </div>
                </Col>
              </Row>
            </>
          )}
          {(type === "other" || type === "others") && (
            <>
              <Row>
                <Col xs={6} lg={5} md={4}>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Supplier Name:
                    </Col>
                    <Col xs={7} className="print-data">
                      {transaction.supplier_name}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Payee:
                    </Col>
                    <Col xs={7} className="print-data">
                      {transaction.payee}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Payment Date:
                    </Col>
                    <Col xs={7} className="print-data">
                      {dateFormat(transaction.payment_date)}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Payment Mode:
                    </Col>
                    <Col xs={7} className="print-data">
                      Others
                    </Col>
                  </div>
                </Col>
                <Col xs={6} lg={5} md={4}>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Type:
                    </Col>
                    <Col xs={7} className="print-data">
                      {transaction.transaction_type}
                    </Col>
                  </div>
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Reference No:
                    </Col>
                    <Col xs={7} className="print-data">
                      {transaction.transaction_no}
                    </Col>
                  </div>
                  {/* <div className="d-flex my-2 align-items-center">
                                        <Col xs={4} className="print-label">
                                            Acknowledged By:
                                        </Col>
                                        <Col xs={7} className="print-data">
                                            {transaction.acknowledged_by}
                                        </Col>
                                    </div> */}
                  <div className="d-flex my-2 align-items-center">
                    <Col xs={4} className="print-label">
                      Remarks:
                    </Col>
                    <Col xs={7} className="print-data">
                      {transaction.particulars}
                    </Col>
                  </div>
                </Col>
              </Row>
            </>
          )}

          {/* <div className="mt-4 d-flex flex-column">
                        <span className="review-data mb-2 nc-modal-custom-row">
                            APPLIED TO THE FOLLOWING INVOICES
                        </span>
                    </div>
                    <div className="d-flex mt-2 justify-content-evenly">
                        <div className="print-table mt-3 mx-2">
                            {renderPrintTable()}
                        </div>
                    </div> */}
          <div className="mt-4 d-flex flex-column">
            <span className="review-data mb-2">
              APPLIED TO THE FOLLOWING INVOICES
            </span>
            <div className="print-table mt-3">{renderPrintTable()}</div>
          </div>
          <Row className="print-grand-total my-2 text-end">
            <Col xs={8} lg={9} md={6} className="print-table-footer-label ">
              TOTAL AMOUNT
            </Col>
            <Col
              xs={3}
              lg={3}
              md={3}
              className="print-table-footer-data text-end"
            >
              {numberFormat(transaction.total_amount)}
            </Col>
          </Row>
          <Row className="print-grand-total my-2 text-end">
            <Col xs={8} lg={9} md={6} className="print-table-footer-label">
              TOTAL WHT
            </Col>
            <Col
              xs={3}
              lg={3}
              md={3}
              className="print-table-footer-data text-end"
            >
              {numberFormat(transaction.withholding_tax_total)}
            </Col>
          </Row>
          <Row className="print-grand-total my-2 text-end">
            <Col xs={8} lg={9} md={6} className="print-table-footer-label">
              SUBTOTAL
            </Col>
            <Col
              xs={3}
              lg={3}
              md={3}
              className="print-table-footer-data text-end"
            >
              {numberFormat(transaction.subtotal)}
            </Col>
          </Row>
          <Row className="print-grand-total my-2 text-end">
            <Col xs={8} lg={9} md={6} className="print-table-footer-label">
              TOTAL OTHERS
            </Col>
            <Col
              xs={3}
              lg={3}
              md={3}
              className="print-table-footer-data text-end"
            >
              {numberFormat(transaction.total_others)}
            </Col>
          </Row>
          <Row className="print-grand-total my-2 text-end">
            <Col xs={8} lg={9} md={6} className="print-table-footer-label">
              GRAND TOTAL
            </Col>
            <Col
              xs={3}
              lg={3}
              md={3}
              className="print-table-footer-data text-end"
            >
              {numberFormat(transaction.grand_total)}
            </Col>
          </Row>

          {type === "check" && (
            <>
              <Row className="print-grand-total my-2 text-end">
                <Col xs={8} lg={9} md={6} className="print-table-footer-label">
                  GRAND TOTAL IN WORDS:
                </Col>
                <Col
                  xs={3}
                  lg={3}
                  md={3}
                  className="print-table-footer-data text-end underline"
                >
                  {numberToWords(transaction.grand_total)}
                </Col>
              </Row>
            </>
          )}
          <div className="">
            <Row className="mt-5">
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <img
                  src={printPI.added_by_name_signature}
                  className="print-logo"
                  alt=""
                />
              </Col>
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <img
                  src={printPI.acknowledged_by_signature}
                  className="print-logo"
                  alt=""
                />
              </Col>
            </Row>
            <Row className="mt-2 mb-5">
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <Row className="print-sig justify-content-center gotham">
                  <p className="print-data underline-border text-center">
                    {" "}
                    {printPI.added_by_name}
                  </p>
                  <p className="print-data text-center mt-3"> Prepared by</p>
                </Row>
              </Col>
              <Col xs={6} className="print-sig justify-content-center d-flex">
                <Row className="print-sig justify-content-center gotham">
                  <p className="print-data underline-border text-center">
                    {printPI.acknowledged_by}
                  </p>
                  <p className="print-data text-center mt-3">
                    {" "}
                    Acknowledged by
                  </p>
                </Row>
              </Col>
            </Row>
            <Row className="d-flex justify-content-center mt-5 pt-5">
              <Col xs={3} className="print-sig justify-content-center d-flex">
                <Row className="print-sig justify-content-center gotham">
                  <p className="print-data underline-border text-center">
                    {/* {printPI.acknowledged_by} */}
                  </p>
                  <p className="print-data text-center mt-3">
                    {" "}
                    Noted by (Client)
                  </p>
                </Row>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}
